module.exports = __webpack_public_path__ + "img/12.5b905129.jpg";